import { render, staticRenderFns } from "./DuplicateComponent.vue?vue&type=template&id=1af1558a&scoped=true"
import script from "./DuplicateComponent.vue?vue&type=script&lang=js"
export * from "./DuplicateComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af1558a",
  null
  
)

export default component.exports